import { chakra } from '@bonusly/design-system';

import { ReactComponent } from '../images/trophy.svg';

export const Trophy = chakra(ReactComponent);
